<template>
  <div>
    <div class="resilient">
      <CCard>
        <CCardHeader align="center">
          <strong>Resilient </strong><small>Score</small>
        </CCardHeader>

        <CCardBody>
          <CRow>
            <CCol sm="6" style="margin-top: 5%">
              <CCard>
<!--                <CCardHeader>-->
<!--                  Welcome-->
<!--                </CCardHeader>-->
                <CCardBody>
                  <p>Welcome to the Starter Grower. Be sure to fill out all questionnaires and improve your score!.</p>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol sm="6">
              <CCard bodyWrapper class="progress_container">
                <div>
                  <Progress
                      :transitionDuration="5000"
                      :radius="50"
                      :strokeWidth="10"
                      :value="score"
                      :strokeColor="color"
                  >
                  </Progress>
                </div>
                <div class="progress_container">
                  <b class="resilient_label">{{label}}</b>
                </div>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>

      </CCard>
    </div>
    <div class="category-form">
      <CCard class="">
        <CCardHeader align="center">
          <strong>Category </strong><small>List</small>
        </CCardHeader>

        <AdvancedTables
            @showQue="setID"
            :table-headers="[
              'name',
              'description'
              ]"
            :json-data="result"
        >
          <CCardBody style="background-color: #ebedef" align="left">
            <CButton size="sm" class="btn btn-primary" @click="viewQuestion()">
              View All Questions
            </CButton>
          </CCardBody>
        </AdvancedTables>
      </CCard>
    </div>
  </div>
</template>

<script>
import AdvancedTables from "@/views/table/AdvancedTables";
import Progress from "easy-circular-progress";
import axios from "axios";

export default {
  name: "Home",
  components: {
    AdvancedTables,
    Progress
  },
  props: ['item'],
  data() {
    return {
      categories: [],
      selected: '',
      result: [],
      score: 0,
      color: '#ff5d66',
      label: ''
    }
  },
  mounted() {
    document.title = 'Starter Grower | Home'
    let self = this;
    const token = localStorage.getItem("api_token")
    axios.get(this.$apiAdress + '/api/category/answer', {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json'
      }
    }).then(function (response) {
      console.log('categories', response)
      self.result = response.data.data
      self.getResilientScore()
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: {
    setID(id) {
      let self = this
      self.selected = id
    },
    viewQuestion() {
      let self = this
      self.$router.push({
        name: 'AnswerForm',
        params: {
          id: self.selected
        }
      });
    },
    getResilientScore() {
      let self = this;
      const token = localStorage.getItem("api_token")
      const company_id = localStorage.getItem("company_id")
      axios.get(this.$apiAdress + '/api/_score/' + company_id, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      }).then(function (response) {
        console.log('resilient score', response)
        self.score = response.data.data.score
        self.setColor(self.score)
      }).catch(function (error) {
        console.log(error);
      });
    },
    setColor(value) {
      const self = this
      if (value >= 75) {
        console.log('Excellent score')
        self.color = '#3ccdd0'
        self.label = 'Excellent'
      } else if (value < 75 && value >= 65) {
        console.log('Very good score')
        self.color = '#8dc53e'
        self.label = 'Very good'
      }else if (value < 65 && value >= 45) {
        console.log('Good score')
        self.color = '#fbdf58'
        self.label = 'Good'
      } else if (value < 45 && value >= 25) {
        console.log('Bad score')
        self.color = '#f7b65c'
        self.label = 'Bad'
      } else if (value < 25) {
        console.log('Very bad score')
        self.color = '#ff5d66'
        self.label = 'Very bad'
      }
    }
  }
}
</script>

<style>
.grid-container {
  background-color: #ebedef;
}

.resilient {
  max-width: 70%;
}

.progress_container {
  /*margin-left: 35%;*/
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

</style>
